import React from 'react';
import PropTypes from 'prop-types';

import {Group} from "./Group";
import {connect} from "react-redux";
import {login} from "../modules/rocketChat/actions/rocketChatAction";


class ContactList extends React.Component {

  static propTypes = {
    onMemberClick: PropTypes.func,
    left: PropTypes.func,
    right: PropTypes.func,
    seniorGroups: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        list: PropTypes.arrayOf(
          PropTypes.shape({
            firstname: PropTypes.string,
            lastname: PropTypes.string,
            imgUrl: PropTypes.string,
            device_id: PropTypes.number,
            prof_id: PropTypes.number
          })
        )
      })
    ),
    rocketChat: PropTypes.shape({isConnected: PropTypes.bool, isLoggedIn: PropTypes.bool}),
    user: PropTypes.shape({email: PropTypes.string}),
    login: PropTypes.func
  };

  static defaultProps = {
    onMemberClick: () => {},
    left: () => {},
    right: () => {},
  };

  componentDidMount() {
    if (this.props.rocketChat.isLoggedIn && !this.props.rocketChat.isConnected) {
      this.props.login(this.props.user.email);
    }
  }

  render() {
    const items = this.props.seniorGroups.map((group, groupIndex) => {
      return (
        <Group key={groupIndex} title={group.title} itemType="selectItem">
          {group.list.map((member, memberIndex) => {
            return (
              <div key={memberIndex}
                   className="seniorOption flexBox direction-row center-center"
                   onClick={() => this.props.onMemberClick(member.prof_id)}>
                <div className="flex left">
                  {this.props.left(member.prof_id)}
                </div>
                <div>
                  <div className="userProfilePic" style={{backgroundImage: `url(${member.imgUrl})`}} />
                  <div className="flex memberName">
                    {member.firstname} {member.lastname}
                  </div>
                </div>
                <div className="flex right">
                  {this.props.right(member.prof_id)}
                </div>
              </div>
            );
          })}
        </Group>
      );
    });

    return (<div>{items}</div>);
  }
}

const mapStateToProps = (state) => {
  return {
    rocketChat: state.rocketChat,
    user: state.user
  };
};


export default connect(mapStateToProps, { login })(ContactList);
